// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"d56bf13f","703":"7c1821de","845":"561c2194"}[chunkId] + ".chunk.js";
};